<template>
  <el-dialog
    title="绑定设备"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose">
    <div>
      <div style="margin-bottom: 1rem;">
        <span>用户: <b>{{ currentUser.username }}</b></span>
      </div>
      
      <div style="margin-bottom: 1rem;">
        <el-input
          placeholder="请输入设备ID进行搜索"
          v-model="searchText"
          clearable
          style="width: 50%; margin-right: 10px;">
        </el-input>
        <el-button type="primary" size="small" @click="searchDevices">搜索</el-button>
      </div>
      
      <div style="display: flex; margin-bottom: 1rem;">
        <div style="flex: 1; margin-right: 1rem;">
          <div style="font-weight: bold; margin-bottom: 0.5rem;">可选设备</div>
          <el-table
            :data="filteredDeviceList"
            height="400"
            border
            style="width: 100%">
            <el-table-column
              prop="deviceId"
              label="设备ID"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="设备名称">
            </el-table-column>
            <el-table-column
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="addDevice(scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <div style="flex: 1;">
          <div style="font-weight: bold; margin-bottom: 0.5rem;">已绑定设备</div>
          <el-table
            :data="selectedDevices"
            height="400"
            border
            style="width: 100%">
            <el-table-column
              prop="deviceId"
              label="设备ID"
              width="180">
            </el-table-column>
            <el-table-column
              prop="name"
              label="设备名称">
            </el-table-column>
            <el-table-column
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="removeDevice(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="saveBindings">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "bindUserDevices",
  data() {
    return {
      dialogVisible: false,
      currentUser: {},
      deviceList: [],
      selectedDevices: [],
      searchText: '',
      callback: null
    };
  },
  computed: {
    filteredDeviceList() {
      if (!this.searchText) {
        return this.deviceList.filter(device => 
          !this.selectedDevices.some(selected => selected.deviceId === device.deviceId)
        );
      }
      return this.deviceList.filter(device => 
        (device.deviceId.includes(this.searchText) || 
        (device.name && device.name.includes(this.searchText))) && 
        !this.selectedDevices.some(selected => selected.deviceId === device.deviceId)
      );
    }
  },
  methods: {
    openDialog(user, callback) {
      this.dialogVisible = true;
      this.currentUser = user;
      this.callback = callback;
      this.loadDevices();
      this.loadUserDevices();
    },
    handleClose() {
      this.dialogVisible = false;
      this.currentUser = {};
      this.deviceList = [];
      this.selectedDevices = [];
      this.searchText = '';
    },
    close() {
      this.dialogVisible = false;
    },
    loadDevices() {
      // 加载所有设备列表
      this.$axios({
        method: 'get',
        url: '/api/device/query/devices',
        params: {
          page: 1,
          count: 1000 // 加载足够多的设备
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.deviceList = res.data.data.list.map(device => ({
            deviceId: device.deviceId,
            name: device.name || device.deviceId
          }));
        }
      }).catch(error => {
        console.error('加载设备列表失败', error);
        this.$message.error('加载设备列表失败');
      });
    },
    loadUserDevices() {
      // 加载用户已绑定的设备
      this.$axios({
        method: 'get',
        url: `/api/user/userDevices`,
        params: {
          userId: this.currentUser.id
        }
      }).then(res => {
        if (res.data.code === 0) {
          const deviceIds = res.data.data;
          this.selectedDevices = [];
          
          // 为每个设备ID查找对应的设备信息
          this.$axios({
            method: 'get',
            url: '/api/device/query/devices',
            params: {
              page: 1,
              count: 1000
            }
          }).then(deviceRes => {
            if (deviceRes.data.code === 0) {
              const allDevices = deviceRes.data.data.list;
              
              // 找出已绑定的设备
              deviceIds.forEach(deviceId => {
                const device = allDevices.find(d => d.deviceId === deviceId);
                if (device) {
                  this.selectedDevices.push({
                    deviceId: device.deviceId,
                    name: device.name || device.deviceId
                  });
                } else {
                  // 如果找不到设备信息，只显示设备ID
                  this.selectedDevices.push({
                    deviceId: deviceId,
                    name: deviceId
                  });
                }
              });
            }
          });
        }
      }).catch(error => {
        console.error('加载用户设备失败', error);
        this.$message.error('加载用户设备失败');
      });
    },
    searchDevices() {
      // 搜索功能已通过计算属性实现
    },
    addDevice(device) {
      this.selectedDevices.push(device);
    },
    removeDevice(device) {
      const index = this.selectedDevices.findIndex(d => d.deviceId === device.deviceId);
      if (index !== -1) {
        this.selectedDevices.splice(index, 1);
      }
    },
    saveBindings() {
      // 保存用户设备绑定
      const deviceIds = this.selectedDevices.map(device => device.deviceId).join(',');
      
      this.$axios({
        method: 'post',
        url: '/api/user/bindDevices',
        params: {
          userId: this.currentUser.id,
          deviceIds: deviceIds
        }
      }).then(res => {
        if (this.callback) {
          this.callback();
        }
      }).catch(error => {
        console.error('保存设备绑定失败', error);
        this.$message.error('保存设备绑定失败');
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialog/bindUserDevices.vue